/**
 * Created by Ella Ma on 12/27/19.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, ComponentRef, ViewChild, Input, OnDestroy, AfterViewInit } from '@angular/core';
import { TamDashboardTileType, TamDashboardActions, TamDashboardEvents } from '../../../components/tam-dashboard/tam-dashboard.model';
import { TamDashboardPieChartTileComponent } from '../../../components/tam-dashboard/tam-dashboard-pie-chart-tile/tam-dashboard-pie-chart-tile.component';
import { TamDashboardColumnChartTileComponent } from '../../../components/tam-dashboard/tam-dashboard-column-chart-tile/tam-dashboard-column-chart-tile.component';
import { TamDashboardLineChartTileComponent } from '../../../components/tam-dashboard/tam-dashboard-line-chart-tile/tam-dashboard-line-chart-tile.component';
import { TamDashboardValueTileComponent } from '../../../components/tam-dashboard/tam-dashboard-value-tile/tam-dashboard-value-tile.component';
import { TamDashboardMetadataTileComponent } from '../../../components/tam-dashboard/tam-dashboard-metadata-tile/tam-dashboard-metadata-tile.component';
import { TamDashboardGridTileComponent } from '../../../components/tam-dashboard/tam-dashboard-grid-tile/tam-dashboard-grid-tile.component';
import { TamDashboardTileBaseComponent } from '../../../components/tam-dashboard/tam-dashboard-tile.base.component';
import { DynamicComponentService } from '../../../services/dynamic-component.service';
import { TamDashboardTileContainerDirective } from '../../../components/tam-dashboard/tam-dashboard-tile-container/tam-dashboard-tile-container.directive';
import { Subscription, Subject } from 'rxjs';
import { TamDashboardPieChartTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-pie-chart-tile/tam-dashboard-pie-chart-tile.config';
import { TamDashboardPopUpService } from '../../../components/tam-dashboard/tam-dashboard-popup.service';
import { TamDashboardColumnChartTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-column-chart-tile/tam-dashboard-column-chart-tile.config';
import { TamDashboardLineChartTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-line-chart-tile/tam-dashboard-line-chart-tile.config';
import { TamDashboardValueTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-value-tile/tam-dashboard-value-tile.config';
import { TamDashboardMetadataTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-metadata-tile/tam-dashboard-metadata-tile.config';
import { DashboardService } from '../../dashboard/dashboard.service';
import { TamDashboardGridTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-grid-tile/tam-dashboard-grid-tile.config';
import { TamDashboardThreadTileComponent } from '../../../components/tam-dashboard/tam-dashboard-thread-tile/tam-dashboard-thread-tile.component';
import { TamDashboardThreadTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-thread-tile/tam-dashboard-thread-tile.config';
import { TamDashboardRichTextTileComponent } from '../../../components/tam-dashboard/tam-dashboard-rich-text-tile/tam-dashboard-rich-text-tile.component';
import { TamDashboardRichTextTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-rich-text-tile/tam-dashboard-rich-text-tile.config';
import { Base64Service } from '../../../tamalelibs/services/base64.service';
import { UtilsService } from '../../../tamalelibs/services/utils.service';
import { DashboardTileService } from '../../../components/tam-dashboard/dashboard-tile.service';
import { TamDashboardMapTileComponent } from '../../../components/tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map-tile.component';
import { TamDashboardMapTileConfiguration } from '../../../components/tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map-tile.config';
import { ContactViewModel } from '../../../tamalelibs/components/contact.view-model';
import { EntityService } from '../../../tamalelibs/services/entity.service';
import { EntityViewModelForWeb } from '../../../components/entity-dialog/entity-view-web.model';
import { ContactService } from '../../../tamalelibs/services/contact.service';
import { StoreQuerierService } from './../../../services/store-querier.service';

@Component({
    selector: 'tam-print-tile-container',
    templateUrl: './print-tile-container.component.html',
    styleUrls: ['./print-tile-container.component.scss']
})
export class PrintTileContainerComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() gsItem;
    @Input() feedbackSubject$: Subject<any>;

    showNoData = false;
    showHeader = true;
    breakPageClass = null;

    private _destroySubscriptions: Array<Subscription> = [];

    @ViewChild(TamDashboardTileContainerDirective, { static: false }) tileContainer: TamDashboardTileContainerDirective;

    constructor(
        private _dynamicComponentService: DynamicComponentService,
        private _dashboardPopUpService: TamDashboardPopUpService,
        private _dashboardService: DashboardService,
        private _dashboardTileService: DashboardTileService,
        private _utils: UtilsService,
        private _base64: Base64Service,
        private _contactViewModel?: ContactViewModel,
        private _entityService?: EntityService,
        private _entityViewModel?: EntityViewModelForWeb,
        private _contactService?: ContactService,
        private _storeQuerier?: StoreQuerierService,
    ) { }

    ngOnInit() {
        this.showNoData = this.gsItem.data === null ||
            (this.gsItem.data && this.gsItem.data.length === 0)
            || (this.gsItem.data && this.gsItem.data.data && this.gsItem.data.data.length === 0);
        if (this.gsItem.config && this.gsItem.config.visualization &&
            this.gsItem.config.visualization.settings) {
            this.showHeader = !this.gsItem.config.visualization.settings.hideHeader;
        }
    }

    ngAfterViewInit() {
        /*
        For grid tiles, the grid-tile component still needs to be created even there's no data, as the excel export function is implemented by it.
        And the excel files without any data still need to be exported.
        */
        if (!this.showNoData || this.isGridTile()) {
            this._initTileComponent(this.gsItem.type);
        } else {
            this.feedbackSubject$.next({
                type: TamDashboardEvents.TILE_AFTER_VIEW_INIT,
                id: this.gsItem.id
            });
            this.feedbackSubject$.next({
                type: TamDashboardEvents.TILE_LOADED_DATA,
                id: this.gsItem.id
            });
        }
        if (this.isGridTile()) {
            this.breakPageClass = this.initBreakPageClass(this.gsItem);
        }
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    getStyle() {
        if (this.gsItem.rows === 6) {
            return {
                'width': '100%',
                'margin-top': '37px'
            };
        }
        return {
            'width': '100%',
            'height': this.gsItem.rows * 150 + 'px'
        };
    }

    isGridTile(): boolean {
        return this.gsItem && this.gsItem.type === TamDashboardTileType.GRID;
    }

    initBreakPageClass(item) {
        let pageBreak = false;
        if (item.config.visualization.settings.gridSetting) {
            pageBreak = item.config.visualization.settings.gridSetting.pageBreak;
        }
        if (pageBreak) {
            return {
                'break-page-after': true
            };
        }
        return null;
    }

    private _initTileComponent(type) {
        const actionSubject$ = new Subject();
        let component: ComponentRef<TamDashboardTileBaseComponent>;
        let config;
        switch (type) {
            case TamDashboardTileType.PIE_CHART:
                component = this._dynamicComponentService.loadComponent<TamDashboardPieChartTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardPieChartTileComponent);
                config = new TamDashboardPieChartTileConfiguration();
                break;
            case TamDashboardTileType.COLUMN_CHART:
            case TamDashboardTileType.BAR_CHART:
                component = this._dynamicComponentService.loadComponent<TamDashboardColumnChartTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardColumnChartTileComponent);
                config = new TamDashboardColumnChartTileConfiguration(null, null, null,
                    this._dashboardPopUpService, type === TamDashboardTileType.BAR_CHART);
                break;
            case TamDashboardTileType.LINE_CHART:
                component = this._dynamicComponentService.loadComponent<TamDashboardLineChartTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardLineChartTileComponent);
                config = new TamDashboardLineChartTileConfiguration();
                break;
            case TamDashboardTileType.VALUE:
                component = this._dynamicComponentService.loadComponent<TamDashboardValueTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardValueTileComponent);
                config = new TamDashboardValueTileConfiguration(this._dashboardTileService);
                break;
            case TamDashboardTileType.METADATA:
                component = this._dynamicComponentService.loadComponent<TamDashboardMetadataTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardMetadataTileComponent);
                config = new TamDashboardMetadataTileConfiguration();
                break;
            case TamDashboardTileType.GRID:
                component = this._dynamicComponentService.loadComponent<TamDashboardGridTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardGridTileComponent);
                config = new TamDashboardGridTileConfiguration(this._dashboardService, null, this._utils, this._dashboardTileService, null, null, this._storeQuerier);
                break;
            case TamDashboardTileType.NOTES:
                component = this._dynamicComponentService.loadComponent<TamDashboardThreadTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardThreadTileComponent);
                config = new TamDashboardThreadTileConfiguration();
                config.isPrintingMode = true;
                config.clickable = true;
                break;
            case TamDashboardTileType.EDITOR:
                component = this._dynamicComponentService.loadComponent<TamDashboardRichTextTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardRichTextTileComponent);
                config = new TamDashboardRichTextTileConfiguration(this._base64, null, this._dashboardTileService);
                break;
            case TamDashboardTileType.MAP:
                component = this._dynamicComponentService.loadComponent<TamDashboardMapTileComponent>
                    (this.tileContainer.viewContainerRef, TamDashboardMapTileComponent);
                config = new TamDashboardMapTileConfiguration(null, this._dashboardTileService, this._contactViewModel, this._entityService, this._entityViewModel);
                break;
            default:
                break;
        }
        if (!config) {
            return;
        }
        this._setWidget(config);
        const isGridTile = this.isGridTile();
        if (isGridTile) {
            const otherGridOptions = {
                domLayout: 'print',
                enableRowGroup: false,
                rowGroupPanelShow: 'never',
                sortable: false,
                resizable: true,
                suppressMenu: true,
                suppressMovable: true,
            };
            const name = this.showHeader ? this.gsItem.name : '';
            config.init(this.gsItem.id, true, name, actionSubject$, this.feedbackSubject$, otherGridOptions);
        } else {
            if (type === TamDashboardTileType.COLUMN_CHART || type === TamDashboardTileType.BAR_CHART ||
                type === TamDashboardTileType.LINE_CHART) {
                config.init(this.gsItem.id, true, this.gsItem.name, actionSubject$, this.feedbackSubject$, 'print');
            } else {
                config.init(this.gsItem.id, true, this.gsItem.name, actionSubject$, this.feedbackSubject$);
            }
        }
        component.instance.setConfig(config);
        this._setLabelSetting(actionSubject$);
        this._setDisplaySettings(actionSubject$);
        if (isGridTile) {
            config.setTileData(this.gsItem);
        } else {
            config.setTileData(this.gsItem.data);
        }
    }

    private _setLabelSetting(actionSubject$) {
        if (!this.gsItem.config || !this.gsItem.config.visualization) {
            return;
        }
        if (this.gsItem.config.visualization.type === TamDashboardTileType.LINE_CHART ||
            this.gsItem.config.visualization.type === TamDashboardTileType.COLUMN_CHART ||
            this.gsItem.config.visualization.type === TamDashboardTileType.BAR_CHART ||
            this.gsItem.config.visualization.type === TamDashboardTileType.PIE_CHART) {
            const series = this.gsItem.config.visualization.settings.series;
            const column = this.gsItem.config.columns.filter(item => item.guid === series);
            if (column && column.length > 0) {
                const dataType = column[0].dataType;
                if (['number', 'currency', 'percent', 'ratio'].indexOf(dataType) !== -1) {
                    actionSubject$.next({
                        id: this.gsItem.id,
                        dataType: dataType,
                        settings: column[0].settings
                    });
                }
            }
        }
    }

    private _setDisplaySettings(actionSubject$) {
        if (!this.gsItem.config || !this.gsItem.config.visualization) {
            return;
        }
        if (this.gsItem.config.visualization.type === TamDashboardTileType.PIE_CHART) {
            actionSubject$.next({
                id: this.gsItem.id,
                type: TamDashboardActions.SET_PIR_CHART_DISPLAY,
                payload: this.gsItem.config.visualization.settings.displaySetting
            });
        }
    }

    private _setWidget(config) {
        if (!this.gsItem.config || !this.gsItem.config.visualization) {
            return;
        }
        if (this.gsItem.config.visualization.type === TamDashboardTileType.GRID ||
            this.gsItem.config.visualization.type === TamDashboardTileType.EDITOR) {
            config.setWidget({
                ...this.gsItem,
                tile: this.gsItem.config
            });
        }
    }
}
